import { render, staticRenderFns } from "./BudgetGlobal.vue?vue&type=template&id=5a8ae90e&scoped=true&"
import script from "./BudgetGlobal.vue?vue&type=script&lang=js&"
export * from "./BudgetGlobal.vue?vue&type=script&lang=js&"
import style0 from "./BudgetGlobal.vue?vue&type=style&index=0&id=5a8ae90e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ae90e",
  null
  
)

export default component.exports